import React from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";

const AddResource = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  countries = [],
  businessUnits = [],
  reportingManagers = [],
  roles = []
}) => {
  const isEdit = !!initialData;
  console.log("initialData", reportingManagers)
  const initialValues = {
    username: initialData?.username || "",
    email: initialData?.email || "",
    mobile: initialData?.mobile || "",
    designation: initialData?.designation || "",
    first_name: initialData?.first_name || "",
    last_name: initialData?.last_name || "",
    previous_year_of_experience: initialData?.previous_year_of_experience || "",
    date_of_joining: initialData?.date_of_joining || "",
    type_of_service: initialData?.type_of_service || "",
    business_unit: initialData?.business_unit?.toString() || "",
    reporting_manager: initialData?.reporting_manager?.toString() || "",
    availability: initialData?.availability || "",
    country_id: initialData?.country_id?.toString() || "",
    employee_code: initialData?.employee_code || "",
    role_id: initialData?.role_id?.toString() || "",
    is_active: initialData?.is_active ?? true,
  };

  const getOptionsForField = (source) => {
    switch (source) {
      case "Country":
        return countries.map((resource) => ({
          value: resource.country_id.toString(),
          label: resource.country_name,
        }));
      case "business_unit":
        return businessUnits.map((businessUnit) => ({
          value: businessUnit.business_unit_id.toString(),
          label: businessUnit.business_unit_name,
        }));
      case "role_id":
        return roles.map((role) => ({
          value: role.role_id.toString(),
          label: role.role_name,
        }));
        case "reporting_manager" :
          return reportingManagers.map((reportingManager) => ({
            value: reportingManager.resource_id.toString(),
            label: reportingManager.username
          }))
      default:
        return [];
    }
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.resource.basic.fields}
      title="Resource"
      icon={AssignmentIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
    />
  );
};

export default AddResource;
